export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const redirects = await $fetch<Record<string, string>>(`/api/redirects`);

    if (redirects[to.path]) {
      return navigateTo(redirects[to.path], { redirectCode: 301 });
    }
  } catch (error) {
    console.error('Failed to fetch redirects:', error);
  }
});
